import React from "react";
import Button from "@mui/material/Button";
import classes from "./emptyState.module.css";

/**
 * Reusable SaaS-style empty state: optional illustration/icon, a title,
 * supporting copy, and an optional primary call-to-action.
 *
 * Props:
 *  - image: illustration src (optional)
 *  - icon: a node rendered inside a circular bubble when no image is given (optional)
 *  - title: short headline
 *  - description: supporting sentence (optional)
 *  - actionLabel + onAction: primary CTA button (optional)
 *  - actionIcon: node rendered before the action label (optional)
 */
const EmptyState = ({
  image,
  icon,
  title,
  description,
  actionLabel,
  onAction,
  actionIcon,
}) => {
  return (
    <div className={classes.container}>
      {image ? (
        <img src={image} alt="" className={classes.illustration} />
      ) : icon ? (
        <span className={classes.iconBubble}>{icon}</span>
      ) : null}

      {title && <p className={classes.title}>{title}</p>}
      {description && <p className={classes.description}>{description}</p>}

      {actionLabel && onAction && (
        <Button
          variant="contained"
          color="primary"
          onClick={onAction}
          className={classes.action}
          startIcon={actionIcon || null}
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
